module.exports = __webpack_public_path__ + "media/images/icons/country_flags/zm-8e1dfbaa6ef2303d8002094fa248e9c2.svg";